import React from 'react';
import { CONFIG } from '../config/global';

const Footer: React.FC = () => {
  return (
    <footer className="bg-text text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-xl font-bold">{CONFIG.company.name}</span>
            </div>
            <p className="text-white/80 leading-relaxed">
              {CONFIG.company.description}
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-white/80">
              <p>{CONFIG.contact.email}</p>
              <p>{CONFIG.contact.phone}</p>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <a 
                href="#about" 
                className="block text-white/80 hover:text-white transition-colors duration-200"
              >
                About
              </a>
              <a 
                href="#features" 
                className="block text-white/80 hover:text-white transition-colors duration-200"
              >
                Features
              </a>
              <a 
                href="#pricing" 
                className="block text-white/80 hover:text-white transition-colors duration-200"
              >
                Pricing
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/60">
          <p>&copy; {new Date().getFullYear()} {CONFIG.company.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
